import { useTranslation } from "react-i18next";
import { PlatformPages } from "@/partner/features/platformPages";
import { Meta } from "@/shared/components";

export const PlatformPagesPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("platformPages.pageTitle")} pageType="Partner" />
      <PlatformPages />
    </>
  );
};
